import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const legacyPinRoute: InvariantJiraRoute = {
	name: 'legacy-pin',
	path: '/projects/:projectKey/issues/:issueKey?',
};
